/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBack = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v20L7.4 12zM6 4.066v15.872H4V4.066zM18 6.13 10.6 12l7.4 5.87z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBack as Back };
